import React, { useContext, useState } from 'react'
import { Formik, Field, Form, FormikHelpers, FormikProps } from 'formik';
import axios from "axios";
import { DatosAppContext } from '../context/DatosAppContext';
import AxiosService from '../services/AxiosService';

type Props = {}

const Contacto = (props: Props) => {

    const [okEnvioFormulario, setOkEnvioFormulario] = useState(false);
    const [errorEnvioFormulario, setErrorEnvioFormulario] = useState(false);
    // const [loaded, setLoaded] = useState(false);

    var tituloSeccion: string = "Contacto";

    const { tokenApi } = useContext(DatosAppContext);

    const valoresIniciales = {
        nombre: '',
        email: '',
        telefono: '',
        consulta: '',
        conociste: '',
        mascota: ''
    };

    interface Values {
        nombre: string;
        email: string;
        telefono: string;
        consulta: string;
        conociste: string;
        mascota: string;
    }

    const envioDatosFormulario = (datosForm: Values, eventoFormulario: FormikHelpers<Values>) => {

            eventoFormulario.setSubmitting(true);

            setOkEnvioFormulario(false);
            setErrorEnvioFormulario(false);

            datosForm.telefono = String(datosForm.telefono);
            
            const url = "/contactos";
            const config = {'headers': {
                'Accept':'application/json', 
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tokenApi
            }};

            AxiosService.post(
                url, 
                datosForm,
                config
            )
            .then((response) => {
                console.log(response)
                if(response.data) {
                    console.log("formulario enviado correctamente");
                    setOkEnvioFormulario(true);
                    eventoFormulario.resetForm();
                }
            })
            .catch((error) => {
                console.log(error)
                setErrorEnvioFormulario(true);
            })
            .finally(()=> {
                eventoFormulario.setSubmitting(false);
            });
            
    }

    const pintarMsgOk = () => {
        return <div className="alert alert-success mt-3" role="alert">
            Consulta enviada correctamete. Pronto recibirá noticias nuestras.
        </div>
    }

    const pintarMsgError = () => {
        return <div className="alert alert-danger mt-3" role="alert">
            Se ha producido un problema. Por favor, intentelo de nuevo más tarde.
        </div>
    }

    const submitForm = ( values: Values, opcionesForm: FormikHelpers<Values> ) => {
        envioDatosFormulario(values, opcionesForm);
    }

    const validationForm = (values: Values) => {

        debugger
        
        let errors: any = {};

        if (values.nombre == "") {
            errors.nombre = 'CAMPO NOMBRE VACIO';
        } else {
            delete errors.nombre;
        }

        if (values.email == "") {
            errors.email = 'CAMPO EMAIL VACIO';
        } else {
            delete errors.email;
        }

        if (values.telefono == "") {
            errors.telefono = 'CAMPO TELEFONO VACIO';
        } else {
            delete errors.telefono;
        }

        if (values.conociste == "") {
            errors.conociste = 'CAMPO COMO CONOCISTE VACIO';
        } else {
            delete errors.conociste;
        }

        if (values.mascota == "") {
            errors.mascota = 'CAMPO MASCOTA VACIO';
        } else {
            delete errors.mascota;
        }

        if (values.consulta == "") {
            errors.consulta = 'CAMPO CONCULTA VACIO';
        } else {
            delete errors.consulta;
        }

        return errors;
    }

    const formulario = () => {
        
        return (  
            <>
            <Formik initialValues = { valoresIniciales }
                    onSubmit = { submitForm }
                    validate = { validationForm } >

                { (props: FormikProps<Values>) => (
                    <Form> 
                                
                        <div className="form-floating mb-3">
                            <Field className={props.errors.nombre?'form-control border-danger':'form-control'} id="nombre" name="nombre" placeholder="Introduce un nombre de contacto" required />
                            <label htmlFor="nombre">Nombre</label>
                        </div>
                        
                        <div className="form-floating mb-3">
                            <Field className={props.errors.email?'form-control border-danger':'form-control'} id="email" name="email" type="email" placeholder="Introduce un correo electrónico de contacto" required />
                            <label htmlFor="email">Correo electrónico</label>
                        </div>
                        
                        <div className="form-floating mb-3">
                            <Field className={props.errors.telefono?'form-control border-danger':'form-control'} id="telefono" name="telefono" type="number" placeholder="Introduce un teléfono de contacto" required />
                            <label htmlFor="telefono">Teléfono</label>
                        </div>

                        <div className="form-floating mb-3">
                            <Field className={props.errors.conociste?'form-control border-danger':'form-control'} id="conociste" name="conociste" as="select" placeholder="¿Como nos conociste?" required >
                                <option defaultValue="">Seleccione opción</option>
                                <option value="buscador">Lo encontré en un buscador</option>
                                <option value="amigo">Un amigo me recomendó</option>
                                <option value="redesSociales">En redes sociales</option>
                                <option value="otro">Otro</option>
                            </Field>
                            <label htmlFor="conociste">¿Como nos conociste?</label>
                        </div>

                        <div className="form-floating mb-3">
                            <Field className={props.errors.mascota?'form-control border-danger':'form-control'} id="mascota" name="mascota" as="select" placeholder="¿Te traes a tu mascota?" required >
                                <option defaultValue="">Seleccione opción</option>
                                <option value="si">Si</option>
                                <option value="no">No</option>
                            </Field>
                            <label htmlFor="mascota">¿Te traes a tu mascota?</label>
                        </div>    

                        <div className="mb-3">
                            <label htmlFor="consulta">Detállanos tu consulta</label>
                            <Field className={props.errors.consulta?'form-control border-danger':'form-control'} id="consulta" name="consulta" as="textarea" placeholder="Escribemos cualquier aclaracion o duda que puedas tener" required />
                        </div>               

                        <div className='d-flex justify-content-center '>
                            <button className="btn btn-primary btn-xl" 
                                id="submitButton" 
                                disabled={props.isSubmitting}
                                type="submit">Enviar Consulta</button>
                        </div>
                        
                    </Form>
                )}
                    
                </Formik>

                {
                    errorEnvioFormulario?pintarMsgError():<></>
                }

                {
                    okEnvioFormulario?pintarMsgOk():<></>
                }

        </>)
    }


  return (
    
    <section className="page-section" id="contacto">

            <div className="container">
                
                <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">
                    { tituloSeccion }
                </h2>
                
                <div className="divider-custom">
                    <div className="divider-custom-line"></div>
                    <div className="divider-custom-icon">
                        <i className="fa-solid fa-message"></i>
                    </div>
                    <div className="divider-custom-line"></div>
                </div>
                
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-xl-7">

                        {
                            formulario()
                        }
                                                
                    </div>
                </div>
            </div>
        </section>

  )
}

export default Contacto